import React, { Component, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";


import WithConversationStorage from '../../components/hoc/WithConversationStorage/WithConversationStorage';
import Eva4Connection from '../../services/eva/Eva4Connection';
import LiveAgentConnexion from '../../services/liveAgent/LiveAgentConnection';
import classes from './ChatContainer.module.css';
import { TextMsg } from '../chatElements/chatClasses';
import ChatHeader from './ChatHeader/ChatHeader';
import ChatBody from './ChatBody/ChatBody';
import ChatFooter from './ChatFooter/ChatFooter';
//import { LoaderOptionsPlugin } from 'webpack';



class ChatContainer extends Component {

    brokerConexion = new Eva4Connection();
    bodyDiv = createRef();

    componentDidMount() {
        if (this.props.isMobile && this.props.sendInitialMessageFlag) {
            this.startConversation();
        }
    }

    componentDidUpdate() {
        if (this.props.sendInitialMessageFlag) {
            this.startConversation();
        }
    }

    startConversation = () => {
        this.props.showSpinner();
        if (window.sessionStorage.getItem('qm_last_page') != null && 
        (window.sessionStorage.getItem('qm_last_page').includes('gestion-de-reservas'))) {
            this.brokerConexion.sendMMBInitialMessage()
                .then(({ messages, sessionCode }) => this.props.addMessages(messages, sessionCode))
                .catch(err => {
                    const errMsg = new TextMsg({ fromUser: false, text: this.props.t('chatcontainer.connection-error-msg'), position: 'First' });
                    this.props.addMessages([errMsg])
                    console.log(err);
                })
        }else{
            this.brokerConexion.sendInitialMessage()
                .then(({ messages, sessionCode }) => this.props.addMessages(messages, sessionCode))
                .catch(err => {
                    const errMsg = new TextMsg({ fromUser: false, text: this.props.t('chatcontainer.connection-error-msg'), position: 'First' });
                    this.props.addMessages([errMsg])
                    console.log(err);
                })
        }
    }

    addUserMessage = (text, options) => {
        if (!text) return;
        const newMsg = new TextMsg({ fromUser: true, text: text, position: 'First' });

        // addMessages gets ARRAY as parameter
        this.props.addMessages([newMsg]);

        // To live agent or regular flow
        if (this.LiveAgentConnexion) {
            this.sendLiveAgenteMessage(text)
        } else {
            this.sendUserMessage(text, options);
        }

    }

    sendLiveAgenteMessage = (text) => {
        this.LiveAgentConnexion.sendMessage(text)
            .catch(() => {
                const newMsg = new TextMsg({ fromUser: false, text: "Error de conexión con el agente", position: 'First' });
                this.props.addMessages([newMsg]);
            })
    }

    sendUserMessage = (text, options) => {
        // Sending user message to the broker
        this.props.showSpinner();
        console.log("SEND USER MESSAGE TEXT: ", text)
        console.log("SEND USER MESSAGE OPTIONS: ", options)

        this.brokerConexion.sendMessage(text, null, { ...this.props.connexionOptions, ...options })
            .then(({ messages, context, sessionCode, liveAgent }) => {
                if (liveAgent) {
                    this.startLiveAgentConversation(messages, context);
                } else {
                    this.props.addMessages(messages, sessionCode);
                }
            })
            .catch(err => {
                const errMsg = new TextMsg({ fromUser: false, text: this.props.t('chatcontainer.connection-error-msg'), position: 'First' });
                this.props.addMessages([errMsg])
                console.log(err);
            })
    }

    startLiveAgentConversation = (messages, context) => {
        console.log('Starting Live Agent Conversation')
        // Starting conversation with an agent
        this.LiveAgentConnexion = new LiveAgentConnexion(this.printLiveAgentMessage, this.stopLiveAgentConversation);
        this.LiveAgentConnexion.getSessionId(context.type, context.subtype, context.service, context.mmb, context.claims, context.idPir, context.typeBag, context.pirCode)
            .then(() => this.props.addMessages(messages))
            .catch(() => {
                const newMsg = new TextMsg({ fromUser: false, text: "Error de conexión con el agente", position: 'First' });
                this.props.addMessages([newMsg]);
            })
    }

    printLiveAgentMessage = (text, err) => {
        let newMsg;
        if (err) {
            newMsg = new TextMsg({ fromUser: false, text: "Error de conexión con el agente", position: 'First' });
        } else {
            newMsg = new TextMsg({ fromUser: false, text: text, position: 'First' });
        }

        this.props.addMessages([newMsg]);
    }

    stopLiveAgentConversation = () => {
        this.LiveAgentConnexion = null;
        const newMsg = new TextMsg({ fromUser: false, text: "La conversación con el agente ha finalizado", position: 'First' });
        this.props.addMessages([newMsg]);
    }

    downloadConversation = () => {
        // This function is not longer in use
        // There are some problems when it is deployed in the served which have to be reviewed
        // Using "printConversation" meanwhile
        const input = this.bodyDiv.current;
        html2canvas(input, {
            scale: 10,
        })
            .then((canvas) => {

                const imgData = canvas.toDataURL("image/png");
                const imgWidth = 210;
                const pageHeight = 295;
                const imgHeight = canvas.height * imgWidth / canvas.width;
                let heightLeft = imgHeight;
                const doc = new jsPDF('p', 'px', "a4");
                let position = 20; // give some top padding to first page

                doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight + 20; // top padding for other pages
                    doc.addPage();
                    doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                const d = new Date();
                doc.save(`iberia_ibot_conversation_${d.getTime()}.pdf`);
            });

    }

    printConversation = () => {
        setTimeout(() => {
            const input = this.bodyDiv.current;
            const mywindow = window.open('', 'PRINT', 'height=400,width=600');

            mywindow.document.write(`<html><head><title> ${this.props.t('chatcontainer.print.header')} </title>`);
            mywindow.document.write('</head><body >');
            mywindow.document.write(`<h1> ${this.props.t('chatcontainer.print.title')} </h1>`);
            mywindow.document.write(input.innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10*/

            mywindow.print();
            mywindow.close();

            return true;
        }, 100)


    }

    render() {
        let chatContainer = '';
        if (this.props.show) {
            chatContainer = (
                <div className={classes.ChatContainer} role="region" aria-labelledby="chatWindowTitle">
                    <h2 id="chatWindowTitle" className="sr-only"> {this.props.t('chatcontainer.title')} </h2>
                    <ChatHeader
                        close={this.props.closeChat}
                        download={this.printConversation}
                        isMobile={this.props.isMobile} />
                    <ChatBody
                        messages={this.props.messages}
                        showSpinner={this.props.spinner}
                        refDiv={this.bodyDiv}
                        sendMsg={this.addUserMessage} />
                    <ChatFooter send={this.addUserMessage} />
                </div>
            )
        }

        return (
            <React.Fragment>
                {chatContainer}
            </React.Fragment>
        );

    }
}


export default withTranslation('global')(WithConversationStorage(ChatContainer));